<template>
  <el-popover placement="bottom" v-model="showModal" trigger="manual">
    <div class="bulk-location-component">
      <div class="search-input">
        <div class="input-container">
          <input placeholder="Search" v-model="searchText" />
        </div>
        <div class="clear-icon" @click="clear" v-show="searchText"></div>
        <div class="search-icon-container">
          <div @click="search" class="search-icon"></div>
        </div>
      </div>
      <div class="search-result-container">
        <div class="loading" v-show="loading">
          <i class="el-icon-loading"></i>
        </div>
        <div
          class="search-item"
          @click="itemClick(model)"
          v-for="model in list"
          :key="model.id"
        >
          <div class="image-container location">
            <div class="image"></div>
          </div>
          <div class="right-container">
            <div class="first-container">
              <div class="title">{{ model.name }}</div>
            </div>
            <div class="des">{{ model.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="reference"
      class="icon location"
      @click="showLocationModal"
      :class="{ empty }"
    ></div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme.less";

.icon {
  height: 24px;
  width: 24px;
  background-size: 16px;
  margin-right: 2px;
  background-repeat: no-repeat;
  background-position: center;

  &:hover,
  &:active {
    &.location {
      background-image: url("../../../../../public/images/bulk/storylist_Location_b red@3x.png") !important;
    }
  }

  &.empty {
    background-image: url("../../../../../public/images/bulk/storylist_Location_b@3x.png") !important;
  }

  &.location {
    background-image: url("../../../../../public/images/bulk/storylist_Location_b red@3x.png");
  }
}

.bulk-location-component {
  width: 224px;
  min-height: 296px;
  max-height: 350px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  padding: 20px 0 0 0;
  display: flex;
  flex-direction: column;

  .search-input {
    border: 1px solid @border-color;
    border-radius: 4px;
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    margin: 0 15px;
    .search-icon-container {
      background: @color-primary;
      height: 24px;
      width: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      cursor: pointer;
      &:hover,
      &:active {
        opacity: 0.8;
      }
      .search-icon {
        width: 13px;
        height: 13px;
        background-size: contain;
        background-image: url("../../../../../public/images/schedule_posts/tag_people/tagpeople_search@3x.png");
      }
    }
    .input-container {
      flex: 1;
      width: auto;
    }
    input {
      font-size: 12px;
      border: 0;
      width: 110px;
    }

    .clear-icon {
      width: 14px;
      height: 14px;
      background-size: contain;
      background-image: url("../../../../../public/images/crop/Close.png");
      cursor: pointer;
      margin: 0 5px;

      &:hover {
        opacity: 0.3;
      }
    }
  }

  .search-result-container {
    overflow: auto;
    flex: 1;
    height: 200px;
    max-height: 200px;
    .loading {
      padding: 5px 15px;
      color: @font-color-gray;

      i {
        font-size: 20px;
      }

      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .search-item {
      height: 60px;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 0 15px;
      width: 224px;

      &:hover,
      &:active {
        background: rgba(0, 0, 0, 0.1);
      }

      .image-container {
        background: white;
        border: 1px solid #cccccc;
        height: 32px;
        width: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .image {
          background-image: url("../../../../../public/images/repost/icon_place@3x.png");
          height: 30px;
          width: 30px;
          background-size: contain;
          border-radius: 50%;
          border: 2px solid white;
        }
      }

      .right-container {
        flex: 1;
        align-items: center;
        padding: 0 15px;
        width: 130px;

        .first-container {
          display: flex;
          align-items: center;

          .title {
            font-size: 14px;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .des {
          font-size: 12px;
          color: @font-color-gray;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

<script>
import _ from "lodash";
import { location } from "../../../../service/instagram";
import { showErrorMsg } from "../../../../utils/errors";
import { mapGetters } from "vuex";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../../../store/mutation-types";
import { permissionValidate } from "../../../../service/publisher";

export default {
  name: "BulkLocationComponent",
  props: {
    empty: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      searchList: [], // 查询结果
      searchText: "", // 输入的查询
      loading: false, // 展示loading
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        if (this.form.location) {
          this.searchText = this.form.location.value;
          this.searchList = [this.form.location];
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    publisher() {
      if (this.form && this.form.publisherIds && this.form.publisherIds[0]) {
        return this.user.linkedInstagramList.find(
          (l) => l.publisherId === this.form.publisherIds[0]
        );
      } else {
        return this.currentPublisher;
      }
    },
    list() {
      return this.searchList;
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * 自动删除权限
     */
    taggingPermission() {
      return this.permission.tagging;
    },
  },
  methods: {
    async showLocationModal() {
      // 验证tag people 权限
      if (!this.taggingPermission) {
        await permissionValidate({ type: "full" });
        return;
      }
      this.showModal = true;
    },
    /**
     * 清空当前选中的location
     */
    clear() {
      this.$emit("clear");
      this.searchText = "";
    },
    search: _.debounce(async function (e) {
      const q = this.searchText;
      try {
        // 如果清空输入则清空location选项
        if (!q) {
          this.clear();
        }
        this.loading = true;
        // 清空原选项
        this.searchList = [];
        this.searchList = await location({ q });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
      }
    }, 500),
    /**
     * 弹出搜索单条点击事件
     * @param item 单条点击事件
     */
    itemClick(item) {
      this.$emit("itemClick", item);
      this.showModal = false;
    },
  },
  async created() {
    this.loading = true;
    try {
      // 先获取推荐位置
      this.nearLocation = await location({});
    } catch (e) {
      showErrorMsg(e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
